import { Element } from "@xmpp/xml"
import { ChatSettings } from "@/reducers/chatsSettingsSlice"
import ChatSettingsParser from "@/lib/chatSettingsParser"
import { CHAT_SETTINGS_NODE } from "@/api/xeps/ChatsSettings"

type ChatSettingsPubSubEvent = {
  type: "create" | "retract"
  chatSettings: ChatSettings | { chatJid: string }
}

export default class ChatSettingsPubSubEventParser {
  static parse = (stanza: Element): ChatSettingsPubSubEvent | undefined => {
    const node = stanza
      .getChild("event")
      ?.getChildByAttr("node", CHAT_SETTINGS_NODE)

    if (!node) return

    if (node.getChild("item")) {
      return {
        type: "create",
        chatSettings: ChatSettingsParser.parseItem(node.getChild("item")!),
      }
    } else if (node.getChild("retract")) {
      return {
        type: "retract",
        chatSettings: { chatJid: node.getChild("retract")?.getAttr("id") },
      }
    }
  }
}
